import { render, staticRenderFns } from "./predictionUsers.vue?vue&type=template&id=45c80c4c&"
import script from "./predictionUsers.vue?vue&type=script&lang=js&"
export * from "./predictionUsers.vue?vue&type=script&lang=js&"
import style0 from "./predictionUsers.vue?vue&type=style&index=0&id=45c80c4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports